import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SetupHeaderButtonType,
  SetupPageHeader,
} from '../../../../../../components/SetupPageHeader';
import { replaceFinalSegment } from '../../../../../../utils/url';
import { CreateJobDto } from '../../../../../../services/applicant_tracking/JobService/CreateJobDto';
import { useStateMachine } from 'little-state-machine';
import { FormState } from 'react-hook-form';
import { JobDetails } from '../../../../../../services/applicant_tracking/JobService/EditJobDto';
import { SetupPageFooter } from '../../../../../../components/SetupPageFooter';
import { buildJobWizardSaveActions } from '../../jobWizardSaveActions';

interface PropTypes {
  formState: FormState<CreateJobDto>;
  jobDetails: JobDetails;
  setupStep: number;
  setSetupStep: (newStep: number, jobDTO: CreateJobDto) => void;
  onSave: () => void;
  onSaveAndContinue: () => void;
  onCancel: () => void;
  onNavigate: () => void;
  isEditFlow: boolean;
  isLoading: boolean;
  isSaving: boolean;
  children?: React.ReactNode;
}

export function JobPostPageLayout(props: PropTypes) {
  const isLoadingOrFormInvalid =
    props.isLoading || props.isSaving || !props.formState.isValid;
  const navigate = useNavigate();
  const { state } = useStateMachine();

  const { headerSaveSlot, footerSaveSlot } = buildJobWizardSaveActions({
    jobDetails: props.jobDetails,
    isEditFlow: props.isEditFlow,
    disabled: isLoadingOrFormInvalid,
    isLoading: props.isSaving,
    onSaveAndContinue: props.onSaveAndContinue,
    onSaveAsDraft: props.onSave,
  });

  const firstItems: SetupHeaderButtonType[] = [
    {
      title: 'Previous',
      type: 'Navigate',
      action: () => {
        props.onNavigate();
        props.setSetupStep(props.setupStep - 1, state.setupJob);
        navigate(replaceFinalSegment('job_details'));
      },
    },
  ];

  const nextButton: SetupHeaderButtonType = {
    title: 'Next',
    type: 'Navigate',
    action: () => {
      props.onNavigate();
      props.setSetupStep(props.setupStep + 1, state.setupJob);
      navigate(replaceFinalSegment('application_form'));
    },
    disabled: isLoadingOrFormInvalid,
  };

  if (props.isEditFlow) {
    firstItems.push(nextButton);
  }

  return (
    <>
      <SetupPageHeader
        title='Job Post'
        firstItems={firstItems}
        intermediateItems={[
          {
            title: 'Cancel',
            type: 'Cancel',
            action: props.onCancel,
          },
        ]}
        {...headerSaveSlot}
      />
      {props.children}
      {!props.isLoading && (
        <SetupPageFooter classNames='mt-4' {...footerSaveSlot} />
      )}
    </>
  );
}
